import { Injectable } from "@angular/core";
import { LoginService } from "./login.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { BACKEND_URI } from "../config/config-vars";
import { HarnessType } from "../models/harness-type.model copy";

const BASE_URL = `${BACKEND_URI}/api/harnessType`;
const GET_ALL_URL = BASE_URL;
const INSERT_URL = BASE_URL;
const UPDATE_URL = (id) => `${BASE_URL}/${id}`;
const GET_BY_ID_URL = (id) => `${BASE_URL}/${id}`;
const DELETE_BY_ID_URL = (id) => `${BASE_URL}/${id}`;

@Injectable({providedIn: 'root'})
export class HarnessTypeService {
    constructor(private http: HttpClient, private loginService: LoginService){}
    
    async getAll(): Promise<HarnessType[]> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.get<HarnessType[]>(GET_ALL_URL)
            );
        }
    }

    async getById(id): Promise<HarnessType> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.get<HarnessType>(GET_BY_ID_URL(id))
            );
        }
    }
    async create(data: HarnessType): Promise<HarnessType> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.post<HarnessType>(INSERT_URL, data)
            );
        }
    }
    async update(id, data: HarnessType): Promise<HarnessType> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.put<HarnessType>(UPDATE_URL(id), data)
            );
        }
    }


    async delete(id): Promise<void> {
        if(this.loginService.isloggedIn) {
            try{
                await firstValueFrom(
                    this.http.delete(DELETE_BY_ID_URL(id))
                );
            }catch(err) {}
            } 
        }      
    }